export default {"src":"/_next/static/media/img36.c257f940.svg","height":269,"width":351,"blurWidth":0,"blurHeight":0};